import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that handles scrolling to anchors on page load and route changes
 */
const PageScrollHandler: React.FC = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Check if the URL has a hash and scroll to the element
    if (location.hash) {
      const id = location.hash.substring(1); // Remove the leading #
      const element = document.getElementById(id);
      
      if (element) {
        // Add a small delay to ensure DOM is fully rendered
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      // If no hash, scroll to top
      window.scrollTo(0, 0);
    }
  }, [location]);
  
  // This component doesn't render anything
  return null;
};

export default PageScrollHandler; 